import { db } from '../../firebaseConfig';
import { doc, collection, updateDoc, query, where, getDocs } from "firebase/firestore";

export async function getPendingApprovalBusinesses() {
    const q = query(collection(db, "Businesses"), where('status', 'in', [['pendingapproval']]));
    const querySnapshot = await getDocs(q);

    const businesses = [];
    querySnapshot.forEach((docSnap) => {
        const data = docSnap.data();
        businesses.push({
            id: docSnap.id,
            bar: data.bar ? data.bar : '',
            userId: data.userId && data.userId.length > 0 ? data.userId[0] : null,
        });
    });

    return businesses;
}

export async function approveBusiness(businessId) {
    const businessRef = doc(db, "Businesses", businessId);
    await updateDoc(businessRef, { status: ['approved'] });
}

export async function denyBusiness(businessId) {
    const businessRef = doc(db, "Businesses", businessId);
    await updateDoc(businessRef, { status: ['denied'] });
}
